import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

const ProjectPhotos = ({projects}) => {


  const navigate = useNavigate();

  const [projectsArr, setProjectsArr] = useState([]);

  useEffect(()=>{
    const pros = Object.values(projects);
    setProjectsArr(pros);
  },[projects])

  useEffect(()=>{
    window.scrollTo(0, 0);
    const pros = Object.values(projects);
    setProjectsArr(pros);
  },[])

  return (
    <div className='min-h-[100vh] bg-[#0a0730] flex flex-col gap-8 items-center py-24 md:pt-36 lg:pt-24 px-6 md:px-12 lg:px-28' >
      <div className='flex flex-col items-center w-[60%] gap-4' >
        <h1 className='text-4xl font-mosk600 text-[#fff]' >Project Photos</h1>
        {/* <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Et, modi! Similique asperiores eos non aliquam assumenda accusantium minima temporibus ipsa.</p> */}
      </div>
      <div className='w-full text-[#fff] flex justify-between items-start py-4 md:py-0' >
          <div className='flex gap-1 font-mosk600 pb-0'>
          <p className='cursor-pointer hidden md:block' onClick={()=> navigate('/projects')}>Projects</p>
          <p className=' hidden md:block'>/</p>
          <p>project Photos</p>
          </div>
      </div>
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 w-full' >
          {
            projectsArr.map((project, index)=>{
              return(
                <div data-aos="fade-up" data-aos-duration={800 + (index <11 ? index*100 : 1000)} key={index} onClick={()=> navigate(`/project/${project.id}`)} className='rounded-md overflow-hidden drop-shadow-sm hover:drop-shadow-lg w-full'>
                  <div className='h-[30vh] md:h-[20vh] lg:h-[35vh] !w-full bg-center bg-cover' style={{backgroundImage: `url(${project.thumbnail})`}} ></div>
                  {/* <img className='h-[35vh] !w-full' src={project.thumbnail} alt="" /> */}
                  <div className='bg-[#272939] py-3 px-4 flex flex-col gap-2'>
                    {/* <div>
                      <img className='h-[6vh] w-fit' src={project.companyLogo} alt="" />
                    </div> */}
                    <span className='flex flex-col items-start justify-between' >
                      <h4 className='text-[#fff] font-mosk600 text-lg 2xl:text-xl' >{project.title}</h4>
                      <p className='cursor-pointer font-mosk600 text-sm text-[#add2ff]' >View gallery</p>
                    </span>
                  </div>
                </div>
              )
            })
          }
      </div>
    </div>
  )
}

export default ProjectPhotos
